enum RateCardDiscountType {
  FIXED_PRICE = "FIXED_PRICE",
  PERCENTAGE = "PERCENTAGE"
}

export default RateCardDiscountType;
